import { UserEntry } from './InvitationUserList'
import { BulkInvitationContextState } from './state/state'
import { CheckedCsvInviteUser, CsvInviteUser, UserInvitationResult } from '../../../store/auth/auth'

const nullFilter = () => true
const incorrectRowsFilter = (userEntry: UserEntry) => {
  const hasVerificationError = 'errors' in userEntry.user && userEntry.user.errors.length > 0
  const hasInvitationError = !!userEntry.invitation?.isError
  return hasInvitationError || hasVerificationError
}

const hasClientOrServerVerificationError = (state: BulkInvitationContextState) => {
  return (
    state.csv.clientSideVerificationError !== null ||
    state.csv.serverSideVerificationErrors.length > 0 ||
    state.users.some((user: CsvInviteUser | CheckedCsvInviteUser) => 'errors' in user && user.errors.length > 0)
  )
}

const isCsvVerificationCompletedWithNoError = (state: BulkInvitationContextState) =>
  state.csv.clientSideVerificationCompleted && state.csv.serverSideVerificationCompleted && !hasClientOrServerVerificationError(state)

const hasInvitationError = (state: BulkInvitationContextState) => {
  return state.invite.results.some((userInvitation: UserInvitationResult) => userInvitation.isError)
}

export { incorrectRowsFilter, nullFilter, isCsvVerificationCompletedWithNoError, hasClientOrServerVerificationError, hasInvitationError }
